export const LoadingBars = () => {
    return (
        <div className="make-it-dark">
            <div className="cssload-container">
                <div className="cssload-zenith"></div>
            </div>
        </div>
    )
};